import styled from 'styled-components';
import { Tabs } from '@insly/qmt-reactjs-ui-lib';

export const TabsStyled = styled(Tabs)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.strokeB};
  .qmt-ui-tabs__tab {
    color: ${({ theme }) => theme.colors.textOff};
    transform: translateY(1px);
    padding-bottom: 60px;
    font-size: 20px;
    
    &:not(:last-child) {
      margin-right: 32px;
    }
    
    &--active,
    &:hover {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const ProfileBody = styled.div<{ isPaddingTop?: boolean, noEdgePadding?: boolean }>`
  display: flex;
  flex-direction: column;
  // noEdgePadding lets the tab content (IDD list) run to the right and bottom
  // edges of the profile area, so its overlaid pagination and status dropdown
  // are not cut off by the body padding.
  padding: ${({ isPaddingTop = true, noEdgePadding }) => `${isPaddingTop ? '32px' : '0'} ${noEdgePadding ? '0' : '60px'} ${noEdgePadding ? '0' : '32px'} 0`};
  flex: 1;
  overflow-y: auto;
`;
